import {Template} from "../../../../components/template/template.jsx";
import StockUnavailabilityGraph from "./components/stock-unavailability-graph.jsx";
import CautionedMaterialsStatusGraph from "./components/cautioned-materials-status-graph.jsx";
import MaterialsHomeActions from "./components/materials-home-actions.jsx";
import MaterialsGraph from "./components/materials-graph.jsx";
import {useQuery} from "@tanstack/react-query";
import materialHomeService from "../../../../services/web/material-home-service.js";

const MaterialsHome = () => {

  const {data: info = null, isLoading} = useQuery({
    queryFn: materialHomeService.getHomeInfo,
    queryKey: ["material-home-info"]
  })

  //grid-cols-[minmax(0,2fr)_minmax(260px,1fr)]
  return(
    <Template isLoading={isLoading}>
      <Template.Header>
        <Template.Title>Materiais</Template.Title>
      </Template.Header>
      <Template.Body className="h-[calc(100vh-53px)] overflow-y-auto grid grid-cols-4 grid-rows-[minmax(400px,1fr)_minmax(400px,1fr)] relative gap-4 p-4!">
        <MaterialsHomeActions/>
        <div className="col-span-4 grid h-full min-h-0 grid-cols-8 gap-4">
          <MaterialsGraph data={info}/>
          <CautionedMaterialsStatusGraph data={info}/>
          <StockUnavailabilityGraph data={info}/>
        </div>
      </Template.Body>
    </Template>
  )
}

export default MaterialsHome;
